import { gql } from "@apollo/client";

export default gql`
  mutation updateMeetingGroupNewPageMutation(
    $meetingGroupId: Int!
    $facilitatorId: Int
    $allowManagementTreeVisibility: Boolean
    $allowAdminVisibility: Boolean
    $allowOrgVisibility: Boolean
    $isFormalOneonone: Boolean
    $transcribeMeetingsByDefault: Boolean
    $addTranscriptionBotToMeetingsByDefault: Boolean
    $meetingBotSetting: MeetingBotSetting
    $detectedOneononeBannerDismissed: Boolean
  ) {
    updateMeetingGroup(
      meetingGroupId: $meetingGroupId
      facilitatorId: $facilitatorId
      allowAdminVisibility: $allowAdminVisibility
      allowManagementTreeVisibility: $allowManagementTreeVisibility
      allowOrgVisibility: $allowOrgVisibility
      isFormalOneonone: $isFormalOneonone
      transcribeMeetingsByDefault: $transcribeMeetingsByDefault
      meetingBotSetting: $meetingBotSetting
      addTranscriptionBotToMeetingsByDefault: $addTranscriptionBotToMeetingsByDefault
      detectedOneononeBannerDismissed: $detectedOneononeBannerDismissed
    ) {
      meetingGroup {
        id
        allowAdminVisibility
        allowManagementTreeVisibility
        allowOrgVisibility
        isFormalOneonone
        detectedOneononeBannerDismissed
        transcribeMeetingsByDefault
        addTranscriptionBotToMeetingsByDefault
        meetingBotSetting
        facilitator {
          id
          name
          avatar
        }
      }
    }
  }
`;
